module.exports = __webpack_public_path__ + "media/images/page/top/mvSp2-2bfa9dabf7a74d8e6be8215fbaf35d08.png";